(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-shop-by-category"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbc-slider')) {
	customElements.define('sbc-slider', class extends HTMLElement {
		connectedCallback() {
			this.section = this.closest('.shop-by-category');
			this.loop = this.getAttribute('data-loop') === 'true';
			this.dotsWrap = this.section ? this.section.querySelector('.sbc-dots') : null;
			this.prevBtn = this.section ? this.section.querySelector('.sbc-prev') : null;
			this.nextBtn = this.section ? this.section.querySelector('.sbc-next') : null;
			this.offset = 0;   /* loop mode: rotation counter */
			this.pos = 0;      /* clamped mode: page index */
			this.busy = false;
			this.moved = 0;

			const refresh = () => {
				this.classList.toggle('sbc-draggable', this.overflowing());
				this.setX(this.restX(), false);
				this.buildDots();
			};
			refresh();
			new ResizeObserver(refresh).observe(this);

			if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
			if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

			this.addEventListener('click', (e) => {
				if (this.moved > 6) {
					e.preventDefault();
					e.stopPropagation();
				}
				this.moved = 0;
			}, true);

			this.initDrag();
		}

		count() { return this.children.length; }

		step() {
			if (this.count() > 1) return this.children[1].offsetLeft - this.children[0].offsetLeft;
			return this.count() ? this.children[0].offsetWidth : this.clientWidth;
		}

		contentEnd() {
			if (!this.count()) return 0;
			const last = this.children[this.count() - 1];
			return last.offsetLeft + last.offsetWidth;
		}

		maxX() { return Math.max(0, this.contentEnd() - this.clientWidth); }

		overflowing() { return this.contentEnd() > this.clientWidth + 2; }

		pages() {
			if (!this.overflowing()) return 1;
			if (this.loop) return this.count();
			return Math.ceil(this.maxX() / this.step() - 0.02) + 1;
		}

		restX() { return this.loop ? 0 : -Math.min(this.pos * this.step(), this.maxX()); }

		setX(x, animate) {
			this.style.transition = animate ? 'transform 0.45s cubic-bezier(0.33, 0, 0.2, 1)' : 'none';
			this.style.transform = 'translate3d(' + x + 'px, 0, 0)';
		}

		afterSlide(fn) {
			let done = false;
			let t;
			const onEnd = (e) => { if (e.target === this && e.propertyName === 'transform') finish(); };
			const finish = () => {
				if (done) return;
				done = true;
				clearTimeout(t);
				this.removeEventListener('transitionend', onEnd);
				fn();
			};
			this.addEventListener('transitionend', onEnd);
			t = setTimeout(finish, 550);
		}

		/* Completed one-card slide forward: rotate first card to the end */
		settleNext() {
			const n = this.count();
			this.busy = true;
			this.afterSlide(() => {
				this.appendChild(this.children[0]);
				this.setX(0, false);
				this.offset = (this.offset + 1) % n;
				this.busy = false;
				this.syncUI();
			});
			this.setX(-this.step(), true);
		}

		go(dir) {
			if (this.busy || !this.overflowing()) return;
			const n = this.count();
			const step = this.step();

			if (this.loop) {
				if (dir > 0) {
					this.settleNext();
				} else {
					/* bring the last card in from the left, then slide to it */
					this.insertBefore(this.children[n - 1], this.children[0]);
					this.setX(-step, false);
					void this.offsetWidth; /* reflow: the jump must not animate */
					this.busy = true;
					this.afterSlide(() => {
						this.offset = (this.offset - 1 + n) % n;
						this.busy = false;
						this.syncUI();
					});
					this.setX(0, true);
				}
				return;
			}

			const next = Math.max(0, Math.min(this.pages() - 1, this.pos + dir));
			if (next === this.pos) return;
			this.pos = next;
			this.busy = true;
			this.afterSlide(() => { this.busy = false; this.syncUI(); });
			this.setX(this.restX(), true);
			this.syncUI();
		}

		goTo(i) {
			if (this.busy || !this.overflowing()) return;
			const n = this.count();
			if (this.loop) {
				let delta = (i - this.offset + n) % n;
				if (delta === 0) return;
				if (delta === 1) return this.go(1);
				if (delta === n - 1) return this.go(-1);
				while (delta--) this.appendChild(this.children[0]);
				this.offset = i;
				this.setX(0, false);
				this.syncUI();
			} else {
				if (i === this.pos) return;
				this.pos = Math.max(0, Math.min(this.pages() - 1, i));
				this.busy = true;
				this.afterSlide(() => { this.busy = false; this.syncUI(); });
				this.setX(this.restX(), true);
				this.syncUI();
			}
		}

		buildDots() {
			if (this.dotsWrap) {
				const pages = this.pages();
				this.dotsWrap.innerHTML = '';
				this.dotsWrap.hidden = pages <= 1;
				for (let i = 0; i < pages; i++) {
					const b = document.createElement('button');
					b.type = 'button';
					b.className = 'sbc-dot';
					b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
					b.addEventListener('click', () => this.goTo(i));
					this.dotsWrap.appendChild(b);
				}
			}
			this.syncUI();
		}

		syncUI() {
			const active = this.loop ? this.offset : this.pos;
			if (this.dotsWrap) {
				this.dotsWrap.querySelectorAll('.sbc-dot').forEach((d, di) => d.classList.toggle('is-active', di === active));
			}
			const off = !this.overflowing();
			if (this.prevBtn) {
				this.prevBtn.hidden = off;
				this.prevBtn.toggleAttribute('disabled', !this.loop && this.pos <= 0);
			}
			if (this.nextBtn) {
				this.nextBtn.hidden = off;
				this.nextBtn.toggleAttribute('disabled', !this.loop && this.pos >= this.pages() - 1);
			}
		}

		initDrag() {
			let active = false;
			let dragging = false;
			let preRotated = false;
			let startX = 0;
			let baseX = 0;
			let dx = 0;

			this.addEventListener('pointerdown', (e) => {
				if (this.busy || !this.overflowing()) return;
				if (e.pointerType === 'mouse') e.preventDefault(); /* stops native image drag */
				active = true;
				dragging = false;
				preRotated = false;
				this.moved = 0;
				startX = e.clientX;
				dx = 0;
				baseX = this.loop ? 0 : this.restX();
			});

			this.addEventListener('pointermove', (e) => {
				if (!active) return;
				dx = e.clientX - startX;
				this.moved = Math.max(this.moved, Math.abs(dx));

				/* A press only becomes a drag after real movement — capturing
				   the pointer right away retargets the release event and
				   swallows the card link's click. */
				if (!dragging) {
					if (Math.abs(dx) < 7) return;
					dragging = true;
					this.setPointerCapture(e.pointerId);
					this.classList.add('sbc-dragging');
				}
				const step = this.step();

				if (this.loop) {
					if (dx > 8 && !preRotated) {
						/* dragging toward the previous card: bring it in from the left */
						this.insertBefore(this.children[this.count() - 1], this.children[0]);
						baseX = -step;
						preRotated = true;
					}
					const x = Math.max(-step, Math.min(preRotated ? 0 : 8, baseX + dx));
					this.setX(x, false);
				} else {
					const x = Math.max(-this.maxX(), Math.min(0, baseX + dx));
					this.setX(x, false);
				}
			});

			const release = (e) => {
				if (!active) return;
				active = false;
				if (!dragging) return; /* plain tap/click: let the link work */
				dragging = false;
				this.classList.remove('sbc-dragging');
				if (this.hasPointerCapture(e.pointerId)) this.releasePointerCapture(e.pointerId);

				const step = this.step();
				const th = Math.min(60, step * 0.18);
				const n = this.count();

				if (this.loop) {
					if (preRotated) {
						if (dx > th) {
							/* complete the previous-card slide */
							this.busy = true;
							this.afterSlide(() => {
								this.offset = (this.offset - 1 + n) % n;
								this.busy = false;
								this.syncUI();
							});
							this.setX(0, true);
						} else {
							/* cancel: slide back, then undo the rotation */
							this.busy = true;
							this.afterSlide(() => {
								this.appendChild(this.children[0]);
								this.setX(0, false);
								this.busy = false;
								this.syncUI();
							});
							this.setX(-step, true);
						}
					} else if (dx < -th) {
						this.settleNext();
					} else {
						this.busy = true;
						this.afterSlide(() => { this.busy = false; });
						this.setX(0, true);
					}
					return;
				}

				const x = Math.max(-this.maxX(), Math.min(0, baseX + dx));
				this.pos = Math.max(0, Math.min(this.pages() - 1, Math.round(-x / step)));
				this.busy = true;
				this.afterSlide(() => { this.busy = false; this.syncUI(); });
				this.setX(this.restX(), true);
				this.syncUI();
			};
			this.addEventListener('pointerup', release);
			this.addEventListener('pointercancel', release);
		}
	});
}

  } catch(e) { console.error(e); }
})();
})();
